


























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import BookingDetailTickets from '@/components/booking/detail/Tickets.vue';
import { IGetBookingDetailResponse } from '@/api/booking';
import {
  IRevokeRequest,
  IRechargeRequest,
  revokeIssuedTickets,
  rechargeTickets,
} from '@/api/tickets';
import {
  IIssuingLog,
  IssuingRecordActionEnum,
  IOperatedTicketDetail,
  IssuingLogActionEnum,
  PlanSettingPrintSpecType,
} from '@/api/types';
import {
  getParticipantName,
  isActionCancelled,
  formatIssuingRecordId,
} from '@/utils/tickets';
import { AppModule } from '@/store/modules/app';
import { BookingModule, IssueTicketReceipt } from '@/store/modules/booking';
import { UserModule } from '@/store/modules/user';
import { translateComponentResource, formatApiError } from '@/utils/index';
import { strDateTime } from '@/utils/date';

@Component({
  name: 'BookingDetailIssuingLogs',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  @Prop({ required: true }) data!: IGetBookingDetailResponse;
  private loading = false;
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;

  get translatedLogHeaders() {
    return [
      { text: this.$t('Id'), value: 'id' },
      // { text: this.$t('Booking Id'), value: 'bookingId' },
      {
        text: this.translateComponentResource('Operated at'),
        value: 'operatedAt',
      },
      { text: this.$t('Account name'), value: 'accountName' },
      { text: this.translateComponentResource('Action'), value: 'action' },
      {
        text: this.translateComponentResource('Operated tickets'),
        value: 'operatedTickets',
      },
      {
        text: this.$t('Reference Id'),
        value: 'referenceId',
      },
      { text: this.$t('Cancel'), value: 'cancel', sortable: false },
    ];
  }

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }

  private getIdText(id: string) {
    return formatIssuingRecordId(id);
  }

  private getOperatedAtText(datetime: string) {
    return strDateTime(datetime);
  }

  private getActionItemClass(log: IIssuingLog) {
    return isActionCancelled(log, this.data.issuingLogs) ? 'line-through' : '';
  }

  private canReprintReceipt(log: IIssuingLog) {
    return (
      (log.action as IssuingRecordActionEnum) ===
        IssuingRecordActionEnum.ISSUE &&
      !isActionCancelled(log, this.data.issuingLogs) &&
      (this.data.printSpecs || []).some(
        ps =>
          (ps.type as PlanSettingPrintSpecType) ===
          PlanSettingPrintSpecType.REPRINT_ISSUED_RECEIPT
      )
    );
  }

  private getOperatedTicketsText(operatedTickets: IOperatedTicketDetail[]) {
    let str = '[';
    for (let i = 0; i < operatedTickets.length; i++) {
      str += `"${operatedTickets[i].title}: ${operatedTickets[i].amount}"`;
      if (i !== operatedTickets.length - 1) {
        str += ', ';
      }
    }
    str += ']';
    return str;
  }

  private showCancelButton(log: IIssuingLog) {
    return (
      ((log.action as IssuingRecordActionEnum) ===
        IssuingRecordActionEnum.ISSUE ||
        (log.action as IssuingRecordActionEnum) ===
          IssuingRecordActionEnum.REFUND) &&
      !isActionCancelled(log, this.data.issuingLogs)
    );
  }

  private disableCancelButton(log: IIssuingLog) {
    if (!this.showCancelButton(log) || !log.forbiddenActions) {
      return false;
    }
    if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.ISSUE
    ) {
      return log.forbiddenActions!.some(
        a => (a as IssuingLogActionEnum) === IssuingLogActionEnum.REVOKE
      );
    } else if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.REFUND
    ) {
      return log.forbiddenActions!.some(
        a => (a as IssuingLogActionEnum) === IssuingLogActionEnum.RECHARGE
      );
    }
    return false;
  }

  private getCancelButtonColor(log: IIssuingLog) {
    if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.ISSUE
    ) {
      return 'error';
    } else if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.REFUND
    ) {
      return 'warning';
    }
    return 'pramary';
  }

  private getCancelButtonText(log: IIssuingLog) {
    if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.ISSUE
    ) {
      return 'Revoke';
    } else if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.REFUND
    ) {
      return 'Recharge';
    }
    return 'Cancel';
  }

  private async handelCancelButtonClick(log: IIssuingLog) {
    if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.ISSUE
    ) {
      await this.handleRevoke(log.id);
      return;
    } else if (
      (log.action as IssuingRecordActionEnum) === IssuingRecordActionEnum.REFUND
    ) {
      await this.handleRecharge(log.id);
      return;
    }
    return;
  }

  private async handleRevoke(revokeRecordId: string) {
    const req = {
      bookingId: this.data.booking.bookingId,
      bookingRecordVersion: this.data.version,
      issuingRecordId: revokeRecordId,
    } as IRevokeRequest;
    try {
      AppModule.ShowOverlay();
      const res = await revokeIssuedTickets(req);
      this.$toast.success(
        `${this.$t('Revoked')}, ${this.$t('Id')}: ${formatIssuingRecordId(
          res.issuingRecordId
        )}`,
        {
          icon: 'mdi-check-circle',
        }
      );
      this.$emit(BookingDetailTickets.ticketsUpdatedEvent);
      AppModule.HideOverlay();
    } catch (err) {
      AppModule.HideOverlay();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Revoke') as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private async handleRecharge(rechargeRecordId: string) {
    const req = {
      bookingId: this.data.booking.bookingId,
      bookingRecordVersion: this.data.version,
      issuingRecordId: rechargeRecordId,
    } as IRechargeRequest;
    try {
      AppModule.ShowOverlay();
      const res = await rechargeTickets(req);
      this.$toast.success(
        `${this.$t('Recharged')}, ${this.$t('Id')}: ${formatIssuingRecordId(
          res.issuingRecordId
        )}`,
        {
          icon: 'mdi-check-circle',
        }
      );
      this.$emit(BookingDetailTickets.ticketsUpdatedEvent);
      AppModule.HideOverlay();
    } catch (err) {
      AppModule.HideOverlay();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Recharge') as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private handleReprintIssueTicketReceipt(issueLog: IIssuingLog) {
    const reprintSpec = (this.data.printSpecs || []).find(
      ps =>
        (ps.type as PlanSettingPrintSpecType) ===
        PlanSettingPrintSpecType.REPRINT_ISSUED_RECEIPT
    );
    if (!reprintSpec) {
      return;
    }

    const receipt = new IssueTicketReceipt();
    receipt.supplierName = this.data.booking.supplierName || '';
    receipt.supplierId = this.data.booking.supplierId || '';
    receipt.accountName = UserModule.name;
    receipt.bookingId = this.data.booking.bookingId || '';
    receipt.activityName = this.data.booking.activityTitle || '';
    receipt.planName = this.data.booking.planTitle || '';
    receipt.participantName = getParticipantName(
      this.data.booking.participantFirstName || '',
      this.data.booking.participantLastName || '',
      AppModule.language
    );
    receipt.reprint = true;
    receipt.tickets = (issueLog.operatedTickets || []).map(t => ({
      ticketName: t.title,
      ticketCount: t.amount,
    }));
    receipt.issuedTime = this.getOperatedAtText(issueLog.operatedAt);
    receipt.autoPrint = reprintSpec.autoPrint;
    BookingModule.SaveBookingIssueTicketReceipt(receipt);

    window.open(`${location.origin}/receipt`, '_blank');
  }

  private resetDialog() {
    this.dialog = false;
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForCancel(log: IIssuingLog) {
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.handelCancelButtonClick(log);
    };
    this.dialog = true;
  }
}
